import React, { useState } from "react";
import api from "services/api";
import { __ } from "services/Translator";

// Asymmetric limit change on an already-set limit: lowering applies immediately;
// raising or removing enters a cooling-off period (and can be cancelled before
// it takes effect). Consumes POST /rg/limit-change. kind = deposit|loss|wager|
// playtime. onChanged re-fetches the limit after an immediate (decrease) apply.
export default function LimitChangeControl(props) {
  const { kind, currency } = props;
  const [editing, setEditing] = useState(false);
  const [amount, setAmount] = useState("");

  const submit = async (removal) => {
    if (!removal && (amount === "" || isNaN(parseFloat(amount)))) {
      props.showAlert(null, __("Please enter a valid amount."), true);
      return;
    }
    if (props.setSpinner) props.setSpinner(true);
    var response = await api.post("/rg/limit-change", {
      limit_kind: kind,
      new_amount: removal ? null : parseFloat(amount),
    });
    if (props.setSpinner) props.setSpinner(false);

    if (response.status === 200) {
      props.showAlert(__("Limit change"), response.data && response.data.message);
      setEditing(false);
      setAmount("");
      if (props.onChanged) props.onChanged();
    } else {
      props.showAlert(null, response.data && response.data.message, true);
    }
  };

  if (!editing) {
    return (
      <button type="button" className="rg_link_btn" onClick={() => setEditing(true)}>
        {__("Change this limit")}
      </button>
    );
  }

  return (
    <div className="rg_limit_change">
      <input
        className="form-control name_value"
        inputMode="decimal"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        placeholder={currency ? __("New amount") + " (" + currency + ")" : __("New amount")}
      />
      <div className="rg_limit_change_btns">
        <button type="button" className="commonBtn pTwoBtn" onClick={() => submit(false)}>
          {__("Request change")}
        </button>
        <button type="button" className="commonBtn borderBtn" onClick={() => submit(true)}>
          {__("Remove limit")}
        </button>
        <button type="button" className="rg_link_btn" onClick={() => setEditing(false)}>
          {__("Cancel")}
        </button>
      </div>
      <p className="rg_limit_change_note">
        <small>
          {__(
            "Lowering a limit applies immediately. Raising or removing it takes effect after a cooling-off period, and you can cancel it before then."
          )}
        </small>
      </p>
    </div>
  );
}
